"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_SCAN_EXTENSIONS = void 0;
exports.isValidScanFileType = isValidScanFileType;
const file_utils_1 = require("./file-utils");
/**
 * The container also registers `.xyz .txt .csv`, deliberately excluded: `readers.text` parses `inf`,
 * an empty field and plain text as `0.0` and counts the row as a valid point, so one bad row
 * fabricates a point thousands of km out and the octree lattice is sized to reach it.
 */
exports.VALID_SCAN_EXTENSIONS = ['.ply', '.e57', '.pcd', '.npy', '.npz', '.las', '.laz', '.copc', '.bpf'];
function isValidScanFileType(filename) {
    return exports.VALID_SCAN_EXTENSIONS.includes((0, file_utils_1.getFileExtension)(filename.toLowerCase()));
}
//# sourceMappingURL=is-valid-scan-file-type.js.map